import { createAction, props } from '@ngrx/store';
import { IGroupedProducts } from '../models/products.model';

export const loadGroupedProductsForSomeoneElse = createAction(
  '[GroupedProductsForSomeoneElse] Load GroupedProductsForSomeoneElse',
  props<{ request: string }>()
);

export const loadGroupedProductsForSomeoneElseSuccess = createAction(
  '[GroupedProductsForSomeoneElse] Load GroupedProductsForSomeoneElse Success',
  props<{ response: IGroupedProducts[] }>()
);

export const loadGroupedProductsForSomeoneElseFailure = createAction(
  '[GroupedProductsForSomeoneElse] Load GroupedProductsForSomeoneElse Failure',
  props<{ error: Error | any }>()
);
